export class ReloadStateTriggerReload {
  static readonly type = '[ReloadState] Trigger reload';

  constructor(public reloadIdentifier: string) {}
}
